import { render, staticRenderFns } from "./myidp.vue?vue&type=template&id=0d9b9248"
import script from "./myidp.vue?vue&type=script&lang=js"
export * from "./myidp.vue?vue&type=script&lang=js"
import style0 from "./myidp.vue?vue&type=style&index=0&id=0d9b9248&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports